import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const create = "create";
const createWithMedia = "createWithMedia";
const createPoll = "createPoll";
const votePoll = "votePoll";
const like = "like";
const unlike = "unlike";
const addComment = "addComment";
const addReply = "addReply";
const savePost = "save";
const likeComment = "likeComment";
const unlikeComment = "unlikeComment";
const unsavePost = "unsave";
const deletePost = "deletePost";
const admindeletePost = "admindeletePost";
const deleteComment = "deleteComment";
const deleteReply = "deleteReply";
const getAllComments = "getAllComments";
const LikeCounts = "LikeCounts";
const LikeCountUsers = "LikeCountUsers";
const usereditPost = "usereditPost";
const editComment = "editComment";

export default {
  UserEditPost(payload) {
    return Repository.post(transformRoute(usereditPost), payload);
  },
  CreatePost(payload) {
    return Repository.post(transformRoute(create), payload);
  },
  createWithMedia(payload) {
    return Repository.post(
      transformRoute(createWithMedia),
      payload,
      formDataConfig
    );
  },
  createPoll(payload) {
    return Repository.post(transformRoute(createPoll), payload);
  },
  votePoll(payload) {
    return Repository.post(transformRoute(votePoll), payload);
  },
  like(payload) {
    return Repository.post(transformRoute(like), payload);
  },
  unlike(payload) {
    return Repository.post(transformRoute(unlike), payload);
  },
  addComment(payload) {
    return Repository.post(transformRoute(addComment), payload);
  },
  addReply(payload) {
    return Repository.post(transformRoute(addReply), payload);
  },
  savePost(payload) {
    return Repository.post(transformRoute(savePost), payload);
  },
  likeComment(payload) {
    return Repository.post(transformRoute(likeComment), payload);
  },
  unlikeComment(payload) {
    return Repository.post(transformRoute(unlikeComment), payload);
  },
  unsavePost(payload) {
    return Repository.post(transformRoute(unsavePost), payload);
  },
  deletePost(payload) {
    return Repository.post(transformRoute(deletePost), payload);
  },
  admindeletePost(payload) {
    return Repository.post(transformRoute(admindeletePost), payload);
  },
  deleteComment(payload) {
    return Repository.post(transformRoute(deleteComment), payload);
  },
  editComment(payload) {
    return Repository.post(transformRoute(editComment), payload);
  },
  deleteReply(payload) {
    return Repository.post(transformRoute(deleteReply), payload);
  },
  getAllComments(payload) {
    return Repository.post(transformRoute(getAllComments), payload);
  },
  LikeCounts(payload) {
    return Repository.post(transformRoute(LikeCounts), payload);
  },
  LikeCountUsers(payload) {
    return Repository.post(transformRoute(LikeCountUsers), payload);
  },
};

const transformRoute = (route) => {
  return `/post/${route}`;
};
